import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

import { getImageUrl } from "../../utility/imageHelper"; // ✅ Import Image Helper
import { slugify } from "../../utility/slugify";

import { useStore } from "../../context/StoreContext";
import { Link } from "react-router-dom";

const AdminAnalytics = () => {
  const [pageViews, setPageViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const { products } = useStore(); // ✅ pull all products into the page


  const pathToPageName = {
    "/": "Home",
    "/about": "About",
    "/contact": "Contact",
    "/services": "Services",
    "/pricing": "Pricing",
    "/portfolio": "Portfolio",
    "/blog": "Blog",
    "/privacy-policy": "Privacy Policy",
    "/terms-of-service": "Terms of Service",
    "/shopping-cart": "Shopping Cart",
    "/our-process": "Our Process",
    "/shipping-returns": "Shipping & Returns",
    "/login": "Login",
    "/signup": "Sign Up",
    "/secure-checkout": "Checkout",
    "/order-details": "Order Details",
    "/order-confirmation": "Order Confirmation",
    "/order-success": "Order Success",
    "/shop-knives/all-knives": "All Knives",
    
    // fallback for dynamic pages
  };

  useEffect(() => {
    const fetchPageViews = async () => {
      try {
        const res = await axios.get("/api/admin/pageviews");
        setPageViews(res.data);
      } catch (error) {
        console.error("Error fetching page views:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageViews();
  }, []);

  

  // 🔥 SPLIT THE DATA
  const normalPages = pageViews.filter(
    (page) => 
      !page.path.startsWith("/shop-knives/category/") &&
      !page.path.startsWith("/shop-knives/knife/")
  );
  const categoryPages = pageViews.filter((page) =>
    page.path.startsWith("/shop-knives/category/")
  );
  const productPages = pageViews.filter((page) =>
    page.path.startsWith("/shop-knives/knife/")
  );


  const productViewData = productPages.map((page) => {
    const segments = page.path.split("/shop-knives/knife/")[1]?.split("/");
    const productId = Number(segments?.[0]); // number!
    const productSlug = segments?.[1];
  
    const matchedProduct = products.find((product) => product.id === productId);
  
    return {
      id: page.id,
      matchedProduct,
      path: page.path,
      view_count: page.view_count,
      updated_at: page.updated_at,
      fallbackSlug: productSlug, // in case no match
    };
  });
  

  return (
    <div className="admin-messages-container">
      <h2 className="messages-title">Page Views</h2>
{/*
        <p style={{ marginBottom: "1rem" }}>
        To see full detailed analytics (sessions, device types, country breakdown, bounce rates, etc.), 
        click below. You must be invited first via your Google account.
        </p>

        <a
        href="https://analytics.google.com/analytics/web/"
        target="_blank"
        rel="noopener noreferrer"
        className="analytics-link"
        >
        📊 View More on Google Analytics
        </a>
*/}

      {loading ? (
        <p className="messages-loading">Loading page views...</p>
      ) : pageViews.length === 0 ? (
        <p className="messages-empty">No page views found.</p>
      ) : (
        <>
          {/* ✅ Normal Pages */}
          <div className="table-section">
            <h3 className="table-section-title">Tracked Pages</h3>
            <div className="table-wrapper">
              <table className="messages-table">
                <thead>
                  <tr>
                    <th>Page</th>
                    <th>Path</th>
                    <th>View Count</th>
                    <th>Last Viewed</th>
                  </tr>
                </thead>
                <tbody>
                  {normalPages.map((page) => (
                    <tr key={page.id}>
                      <td>{pathToPageName[page.path] || page.path}</td>
                      <td>{page.path}</td>
                      <td>{page.view_count}</td>
                      <td>{new Date(page.updated_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ✅ Category Pages */}
          <div className="table-section">
            <h3 className="table-section-title">Category Pages</h3>
            <div className="table-wrapper">
              <table className="messages-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Path</th>
                    <th>View Count</th>
                    <th>Last Viewed</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryPages.map((page) => (
                    <tr key={page.id}>
                      <td>{page.path.split("/shop-knives/category/")[1]}</td>
                      <td>{page.path}</td>
                      <td>{page.view_count}</td>
                      <td>{new Date(page.updated_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ✅ Product Pages */}
          <div className="table-section">
            <h3 className="table-section-title">Product Pages</h3>
            <div className="table-wrapper">
              <table className="messages-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Path</th>
                    <th>View Count</th>
                    <th>Last Viewed</th>
                  </tr>
                </thead>
                <tbody>
                    {productViewData.map(({ id, matchedProduct, path, view_count, updated_at, fallbackSlug }) => (
                        <tr key={id}>
                        <td>
                            <ul style={{ paddingLeft: 0, margin: 0, listStyle: "none" }}>
                            {matchedProduct ? (
                                <Link
                                className="orders-view-product-page"
                                to={`/shop-knives/knife/${matchedProduct.id}/${slugify(matchedProduct.name)}`}
                                >
                                <li className="order-product">
                                    <img
                                    src={matchedProduct.images?.[0] ? getImageUrl(matchedProduct.images[0]) : "/default-product.jpg"}
                                    alt={matchedProduct.name}
                                    className="order-product-img"
                                    />

                                    <div className="order-product-details">
                                    <span className="product-name">{matchedProduct.name}</span>
                                    <span className="product-price">${matchedProduct.price}</span>
                                    </div>
                                </li>
                                </Link>
                            ) : (
                                <li className="order-product">
                                <span className="product-name">{decodeURIComponent(fallbackSlug || "Unknown Product")}</span>
                                </li>
                            )}
                            </ul>
                        </td>
                        <td>{path}</td>
                        <td>{view_count}</td>
                        <td>{new Date(updated_at).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>




              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminAnalytics;